import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-queue-manager',
  templateUrl: './queue-manager.component.html',
  styleUrls: ['./queue-manager.component.scss']
})
export class QueueManagerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
